export interface PlatformConfig {
  name: string;
  icon: string;
  color: string;
  limits: {
    text?: number;
    headline?: number;
    description?: number;
    linkDescription?: number;
    hashtags?: number;
    mentions?: number;
    article?: number;
    title?: number;
    tags?: number;
    thread?: number;
    eventTitle?: number;
    eventDescription?: number;
    offerTitle?: number;
    offerTerms?: number;
  };
  postTypes: string[];
}

export const PLATFORMS: Record<string, PlatformConfig> = {
  facebook: {
    name: 'Facebook',
    icon: 'https://vistasocial.com/assets/facebook.svg',
    color: '#1877F2',
    limits: {
      text: 5000,
      headline: 40,
      description: 125,
      linkDescription: 30
    },
    postTypes: ['Text', 'Image', 'Video', 'Link', 'Event', 'Poll']
  },
  instagram: {
    name: 'Instagram',
    icon: 'https://vistasocial.com/assets/instagram.svg',
    color: '#E4405F',
    limits: {
      text: 2200,
      hashtags: 30,
      mentions: 10
    },
    postTypes: ['Feed', 'Stories', 'Reels', 'IGTV', 'Carousel']
  },
  linkedin: {
    name: 'LinkedIn',
    icon: 'https://vistasocial.com/assets/linkedin.svg',
    color: '#0077B5',
    limits: {
      text: 3000,
      article: 110000,
      headline: 100
    },
    postTypes: ['Text', 'Article', 'Image', 'Video', 'Document', 'Poll', 'Event']
  },
  twitter: {
    name: 'X',
    icon: 'https://vistasocial.com/assets/twitter.svg',
    color: '#000000',
    limits: {
      text: 280,
      thread: 25
    },
    postTypes: ['Tweet', 'Thread', 'Image', 'Video', 'Poll', 'Spaces']
  },
  youtube: {
    name: 'YouTube',
    icon: 'https://vistasocial.com/assets/youtube.svg',
    color: '#FF0000',
    limits: {
      title: 100,
      description: 5000,
      tags: 500
    },
    postTypes: ['Video', 'Shorts', 'Premiere', 'Live', 'Community Post']
  },
  googlebusiness: {
    name: 'Google Business',
    icon: 'https://vistasocial.com/assets/googlebusiness.svg',
    color: '#4285F4',
    limits: {
      text: 4500,
      eventTitle: 58,
      eventDescription: 1500,
      offerTitle: 58,
      offerTerms: 120
    },
    postTypes: ['Update', 'Offer', 'Event', 'Product', 'COVID Update']
  }
};

export type PlatformKey = keyof typeof PLATFORMS;